module.exports = __webpack_public_path__ + "assets/logo2026carrevert.5c65f521e87ce73bba583c5fbbec335c.svg";